import classNames              from 'classnames';
import * as React              from 'react';
import { useTranslation }      from 'react-i18next';
import { useHistory }          from 'react-router-dom';
import DV                      from 'ts-data-validator';
import { LocalStorageService } from 'ts-storage-service';

import { useCommon }       from '../../providers/common';
import { useCompare }      from '../../providers/compare';
import { useCompareModal } from '../../providers/compareModal';

import CompareIcon from '../icons/CompareIcon';

import RenderButton from './base/RenderButton';

const CompareButton = function(props) {
  const history = useHistory();
  const { t }   = useTranslation();

  const {
          offer,
          isInterior,
          isCatalogCompareBtn,
        } = props;

  const common       = useCommon();
  const compare      = useCompare();
  const compareModal = useCompareModal();

  const ls = new LocalStorageService();

  const [isOfferInStorage, setIsOfferInStorage] = React.useState(false);

  const storage       = React.useMemo(() => {
    return isInterior ? 'interior' : 'entrance';
  }, [isInterior]);
  const isOfferExists = React.useMemo(() => {
    return compare.tradeOffers[storage]?.includes(offer?.offerId);
  }, [compare.tradeOffers, offer, storage]);

  const addOfferToCompare = React.useCallback(() => {
    if (!isOfferExists) {
      const updatedOffers = {
        ...compare.tradeOffers,
        [storage]: [...compare.tradeOffers[storage], offer.offerId],
      };

      ls.setData('compare_offers', updatedOffers);

      compare.setCompareTradeOffers(updatedOffers);

      setIsOfferInStorage(true);

      compareModal.showCompareModal(offer.label, t('client_compare.add'));
    }
  }, [compare.tradeOffers, isOfferExists, offer, storage]);
  const handleOfferAction = React.useCallback((event) => {
    event.stopPropagation();

    if (isOfferInStorage && !isCatalogCompareBtn) {
      history.push({
        pathname: common.getUrlByTemplate('compare'),
        search:   `?type=${storage}`,
      });
    } else if (isOfferInStorage && isCatalogCompareBtn) {
      const newCompareOffers = {
        ...compare.tradeOffers,
        [storage]: compare.tradeOffers[storage].filter((id) => id !== offer.offerId),
      };

      compare.setCompareTradeOffers(newCompareOffers);

      ls.setData('compare_offers', newCompareOffers);

      compareModal.showCompareModal(offer.label, t('client_compare.delete'));
    } else {
      addOfferToCompare();
    }
  }, [addOfferToCompare, compare.tradeOffers, isOfferInStorage, offer, storage]);

  React.useEffect(() => {
    const storedOffers = ls.getData('compare_offers');

    if (!DV.isObject(storedOffers)) {
      ls.setData('compare_offers', {
        entrance: [],
        interior: [],
      });
    }

    if (storedOffers) {
      compare.setCompareTradeOffers(storedOffers);
    }
  }, []);
  React.useEffect(() => {
    setIsOfferInStorage(!!isOfferExists);
  }, [isOfferExists]);

  return (
    <span className={'compare_container'}>
      <span className={'compare_icon_wrapper'}>
      <RenderButton
        className={'compare_btn'}
        icon={<CompareIcon isOfferExists={isOfferInStorage} />}
        action={handleOfferAction}
      />
        {!!compare.tradeOffers[storage]?.length &&
          <span
            className={classNames('offers_counter', { hidden: isCatalogCompareBtn })}
          >
            {compare.tradeOffers[storage].length}
            </span>
        }
      </span>
      <span className={classNames('compare_hint', { hidden: isCatalogCompareBtn })}>{isOfferInStorage
        ? t('client_compare_hint_go')
        : t('client_compare_hint_add')}
      </span>
    </span>
  );
};

export default CompareButton;